'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _iconfont = require('@/components/iconfont');

var _iconfont2 = _interopRequireDefault(_iconfont);

var _modalWechatRem = require('@/components/modal-wechat-rem');

var _modalWechatRem2 = _interopRequireDefault(_modalWechatRem);

var _config = require('@/config');

var _vuex = require('vuex');

var _utils = require('@/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var authtimetimer = function authtimetimer() {
  var _this = this,
      _arguments = arguments;

  var fn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
  var delay = arguments[1];

  var assert = fn.apply(this);
  if (assert) return;
  setTimeout(function () {
    authtimetimer.apply(_this, _arguments);
  }, delay);
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: {
    Modal: _modalWechatRem2.default,
    Iconfont: _iconfont2.default
  },
  data: function data() {
    var _this2 = this;

    return {
      showLoginModal: false,
      formInline: {
        user: '',
        password: '',
        vcode: ''
      },
      ruleInline: {
        user: [{ required: true, message: '手机号不能为空', trigger: 'blur' }, {
          validator: function validator(rule) {
            var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
            var resolve = arguments[2];

            if (!value.trim()) return resolve();
            _utils.phoneNumber.validator.apply(_utils.phoneNumber, arguments);
          },

          trigger: 'blur'
        }],
        password: [{ required: true, message: '验证码不能为空', trigger: 'blur' }],
        vcode: [{ required: true, message: '图形验证码不能为空', trigger: 'blur' }, {
          validator: function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(rule, value, resolve) {
              return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return _this2.$ajax({
                        url: 'user/validateCaptcha',
                        method: 'GET',
                        preventMessage: true,
                        data: {
                          captcha: _this2.formInline.vcode
                        }
                      }).then(function (_ref2) {
                        var data = _ref2.data;

                        if (data.code == 5000) {
                          resolve(new Error('图形验证码错误'));
                        }
                        resolve();
                      }).catch(function () {
                        resolve(new Error('图形验证码错误'));
                      });

                    case 2:
                    case 'end':
                      return _context.stop();
                  }
                }
              }, _callee, _this2);
            }));

            return function validator(_x3, _x4, _x5) {
              return _ref.apply(this, arguments);
            };
          }(),
          trigger: 'sendPhoneVcode'
        }]
      },
      vcode: Math.random(),
      isSend: false,
      pwdFlag: true,
      sendAuthCode: true,
      auth_time: 0,
      IS_SEND_SMS_PRE_CHECK_CAPTCHA: false,
      IS_SEND_SMS: false
    };
  },

  computed: {
    getVcode: function getVcode() {
      return _config.prefixPath + 'user/generateCaptchaImage?' + this.vcode;
    }
  },
  created: function created() {},

  methods: (0, _extends3.default)({}, (0, _vuex.mapMutations)({
    authToken: 'TOKEN',
    LOGIN_SUCCESS_NOTIFY: 'LOGIN_SUCCESS_NOTIFY'
  }), (0, _vuex.mapActions)({
    login: 'loginValidate'
  }), {
    open: function open(url) {
      this.auth_time = 0;
      sessionStorage.removeItem('auth_time');
      // 获取登录配置
      this.getselectList();
      this.sendAuthCode = true;
      this.formInline = {
        user: '',
        password: '',
        vcode: ''
        // state控制回调地址，用sessionStorage.gotoQueryPage来控制
      };var _jumpUrl = sessionStorage.gotoQueryPageAll ? sessionStorage.gotoQueryPageAll : location.origin + '/#' + sessionStorage.gotoQueryPage;
      var opentype = sessionStorage.gotoQueryPageAll ? 'blank' : 'location';
      sessionStorage.opentype = opentype;
      this.state = encodeURIComponent(window.btoa(url || _jumpUrl));
      this.showLoginModal = true;
    },
    getselectList: function getselectList() {
      var _this3 = this;

      this.$ajax({
        url: 'api-basic/portal/open/config/enum/selectList',
        method: 'get',
        data: {
          code: 'login'
        }
      }).then(function (_ref3) {
        var data = _ref3.data;

        var arr = data.data || [];
        arr.forEach(function (v) {
          if (v.code == 'IS_SEND_SMS_PRE_CHECK_CAPTCHA') {
            if (v.name == '1') {
              _this3.IS_SEND_SMS_PRE_CHECK_CAPTCHA = true;
            } else {
              delete _this3.ruleInline.vcode;
            }
          }
          if (v.code == 'IS_SEND_SMS') {
            if (v.name == '1') {
              _this3.IS_SEND_SMS = true;
            } else {
              delete _this3.ruleInline.password;
            }
          }
        });
      });
    },
    validateField: function validateField(prop) {
      var _this4 = this;

      return new _promise2.default(function (resolve, reject) {
        _this4.$refs.formInline.validateField(prop, function (res) {
          if (!res) return resolve();
          console.error('' + prop + _this4.$t('login.failTips'));
          /* eslint-disable*/
          reject();
        });
      });
    },
    sendPhoneVcode: function sendPhoneVcode() {
      var _this5 = this;

      if (!sessionStorage.getItem('auth_time')) {
        if (this.sendAuthCode) {
          _promise2.default.all([this.validateField('user'), this.validateField('vcode')]).then(function () {
            _this5.$ajax({
              url: 'api-basic/portal/open/sms/sendDxSms',
              method: 'get',
              data: {
                mobile: _this5.formInline.user
              }
            }).then(function (_ref4) {
              var data = _ref4.data;

              if (data.code == '2000') {
                _this5.sendAuthCode = false;
                _this5.auth_time = sessionStorage.getItem('auth_time') || 120;
                authtimetimer.call(_this5, function () {
                  this.auth_time--;
                  sessionStorage.setItem('auth_time', this.auth_time);
                  if (this.auth_time <= 0) {
                    this.sendAuthCode = true;
                    sessionStorage.removeItem('auth_time');
                    return true;
                  }
                  return false;
                }, 1000);
                _this5.$Message.success('发送成功');
              } else if (data.code == '5000') {
                _this5.$Message.error(data.message);
              }
              _this5.changeVcode();
            }).catch(function () {
              _this5.changeVcode();
            });
          });
        }
      } else {
        this.auth_time = sessionStorage.getItem('auth_time') || 120;
        authtimetimer.call(this, function () {
          this.auth_time--;
          sessionStorage.setItem('auth_time', this.auth_time);
          if (this.auth_time <= 0) {
            this.sendAuthCode = true;
            sessionStorage.removeItem('auth_time');
            return true;
          }
          return false;
        }, 1000);
      }
    },

    // 关闭登录模态
    onCancel: function onCancel() {
      this.isAgree = false;
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.$store.commit('FLUSHCONTENT', '');
    },
    handlePassword: function handlePassword() {
      this.pwdFlag = !this.pwdFlag;
    },
    changeVcode: function changeVcode() {
      this.vcode = Math.random();
    },

    // 登录
    submitLogin: function submitLogin() {
      var _this6 = this;

      // this.$refs.formInline.validate((validate) => {
      _promise2.default.all([this.validateField('user'), this.validateField('password')]).then(function () {
        //校验成功,发送中直接return
        if (_this6.isSend) return;
        _this6.isSend = true;
        // if (validate) {
        //   this.isSend = true
        // }
        _this6.login(_this6).then(function (res) {
          location.search = '';
          _this6.authToken(true);
          sessionStorage.setItem('authLogin', 'login');
          _this6.showLoginModal = false;
          _this6.$store.commit('FLUSHCONTENT', '');
          _this6.LOGIN_SUCCESS_NOTIFY('NOTIFY_LOGIN_SUCCESS_REFRESH_USER_INFO');
          _this6.$Message.success('登录成功');
          if (sessionStorage.getItem('historyQuery')) {
            var historyQuery = JSON.parse(sessionStorage.getItem('historyQuery'));
            _this6.$router.push(historyQuery);
            setTimeout(function () {
              sessionStorage.removeItem('historyQuery');
            });
          } else {
            location.reload();
            // this.$router.push(indexRouter)
          }
        }).catch(function (_ref5) {
          var data = _ref5.data;

          _this6.loginFail(data);
        }).finally(function () {
          _this6.isSend = false;
        });
      });
    },
    loginFail: function loginFail(data) {
      var message = '登录异常，请重试';
      if (data && data.message) {
        // if (data.status == 401) {
        //   message = '用户名或密码错误'
        // } else if (data.status == 500) {
        //   message = '验证码错误'
        // } else {
        //   message = data.message
        // }
        message = data.message;
      }
      this.$Message.error({
        content: message,
        duration: 6,
        closable: true
      });
      this.changeVcode();
    }
  })
};